
import { ReactNode, useEffect, useState } from "react";
import { AppSidebar } from "@/components/AppSidebar";
import BrandHeader from "@/components/BrandHeader";
import BottomNavigation from "@/components/BottomNavigation";
import Footer from "@/components/Footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="min-h-screen flex w-full">
      <AppSidebar />
      <div className="flex-1 flex flex-col">
        <BrandHeader />
        <main className={`flex-1 ${isMobile ? 'pb-16' : 'pb-0'}`}>
          {children}
        </main>
        <Footer />
        <BottomNavigation />
      </div>
    </div>
  );
};

export default Layout;
